var _path, _path2, _mask, _ellipse, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66602 9.25614C2.66602 8.11254 2.66602 7.54074 2.89296 7.10589C3.0822 6.7433 3.37806 6.44744 3.74066 6.2582C4.17551 6.03125 4.74731 6.03125 5.89091 6.03125H10.1078C11.2514 6.03125 11.8232 6.03125 12.258 6.2582C12.6206 6.44744 12.9165 6.7433 13.1057 7.10589C13.3327 7.54074 13.3327 8.11254 13.3327 9.25614V9.25614C13.3327 10.9715 13.3327 11.8292 12.9923 12.4815C12.7084 13.0254 12.2646 13.4692 11.7207 13.7531C11.0684 14.0935 10.2107 14.0935 8.49535 14.0935H7.50335C5.78795 14.0935 4.93025 14.0935 4.27798 13.7531C3.73409 13.4692 3.29029 13.0254 3.00644 12.4815C2.66602 11.8292 2.66602 10.9715 2.66602 9.25614V9.25614Z",
    stroke: "#858B99",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6654 5.35926V4.66667C10.6654 3.19391 9.47146 2 7.9987 2V2C6.52594 2 5.33203 3.19391 5.33203 4.66667V5.35926",
    stroke: "#858B99",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-3-inside-1",
    fill: "white"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99935,
    cy: 10.0625,
    rx: 1.33333,
    ry: 1.3437
  }))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99935,
    cy: 10.0625,
    rx: 1.33333,
    ry: 1.3437,
    fill: "#858B99"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.83268 10.0625C7.83268 9.98711 7.89637 9.90616 7.99935 9.90616V12.9062C9.57509 12.9062 10.8327 11.622 10.8327 10.0625H7.83268ZM7.99935 9.90616C8.10233 9.90616 8.16602 9.98711 8.16602 10.0625H5.16602C5.16602 11.622 6.42361 12.9062 7.99935 12.9062V9.90616ZM8.16602 10.0625C8.16602 10.1378 8.10233 10.2188 7.99935 10.2188V7.21875C6.42361 7.21875 5.16602 8.5029 5.16602 10.0625H8.16602ZM7.99935 10.2188C7.89637 10.2188 7.83268 10.1378 7.83268 10.0625H10.8327C10.8327 8.5029 9.57509 7.21875 7.99935 7.21875V10.2188Z",
    fill: "#858B99",
    mask: "url(#path-3-inside-1)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocked);
export default __webpack_public_path__ + "static/media/locked.e6f6248891ede054fb3831aa37325926.svg";
export { ForwardRef as ReactComponent };